
import React, { useEffect,useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { getAxiosResponse, putAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Select from "react-select";
import { departmentSelected } from "../../redux/reducers/CreateProjectDepartmentSelectSlice";
import {projectCreationStepFilter } from '../../redux/reducers/ProjectCreationStepSlice';
import { updateDepartment, updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import images from "../../images";
import { RotatingLines } from "react-loader-spinner";
import { updateProjectInfoConfiguration } from "../../redux/reducers/ProjectInfoConfigurationSlice";
import { updateContentType } from "../../redux/reducers/CreateProjectContentTypeSlice";
import { setSelectedTreeData, resetTree } from "../../redux/reducers/TreeSlice"
import Constants from '../../Constants'
import { useNavigate, useParams } from 'react-router-dom';
import { transformBlankToNull } from '../../services/Util';

import { useTranslation } from "react-i18next";
import { resetProjectRequestIntegrationValue } from "../../redux/reducers/ProjectRequestIntegrationSlice";

import { tourStep } from "../../redux/reducers/TourSlice";
import { updateAssetType } from "../../redux/reducers/CreateProjectAssetTypeSlice";
import $ from "jquery";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { updateReadyForValidation, updateValidationErrors } from "../../redux/reducers/AsyncAssetUploadSlice";


export default function SelectAssetType() {

  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;

  const param = useParams();
  const dispatch = new useDispatch();
  const [integrationTypes,setIntegrationTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [userPreference, setUserPreference] = useState();
  const [errorData, setErrorData] = useState(false);
  const [contentTypeStatus, setContentTypeStatus] = useState(true);

  const[globalOverlay,showGlobalOverlay] = useState(true);

  const { t } = useTranslation();
  const navigate=useNavigate();

  const translate = t;

  const searchParams = new URLSearchParams(window.location.search);
  const depLabel = searchParams.get('label');
  const depValue = searchParams.get('value');
  const projectType = searchParams.get('projectType');
  
  const SelectDepartmentRedux = useSelector((reduxStore) => reduxStore.select_department_for_project_creation).value;
  const asyncAssetUploadInfo = useSelector((reduxStore) => reduxStore.asset_upload_background).value;

  const projectData = useSelector(
		(reduxStore) => reduxStore.project_info
	).value;
	const projectCreationStep = useSelector(
		(reduxStore) => reduxStore.project_creation_step
	  ).value;

    useEffect(() => {
      if(projectData?.userGroup !== undefined && projectData?.userGroup?.id !== null){
        dispatch(departmentSelected({label:projectData?.userGroup?.name,value:projectData?.userGroup?.id}))
      }
      else if(projectType==="clone"){
        dispatch(departmentSelected({label:depLabel,value:+depValue}))
      }
       else if (departments?.length > 0){
        dispatch(departmentSelected(departments[0]))
      }
    }, [departments])
    

    useEffect(() => {
    getAxiosResponse(APIUrls.PROJECT_TYPE)
      .then((res) => {
        if (res.data.code === 200) {
          setIntegrationTypes(res.data.data)
          showGlobalOverlay(false);
        }        
      })
      .catch((err) => {
        handleError(err);
      });

      getAxiosResponse(APIUrls.PROJECT_CONTENT_TYPE_USER_PREFERENCE)
      .then((res) => {
        if (res.data.code === 200) {
          setUserPreference(res.data.data.body)
        }
      }).catch((err) => {
        handleError(err);
      });

      getAxiosResponse(APIUrls.EXTERNAL_PROJECT_TYPE)
      .then((res) => {
      }).catch((err) => {
        handleError(err);
      });
      getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED)
      .then((res) => {        
        if (res.data.code === 200) {  
          const options = res.data.data.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          if(options.length>0){
            setDepartments(options);
          }else {
            const unassigned = res.data.data.map(({ id, name }) => ({
              label: name,
              value: id,
            }));
            dispatch(departmentSelected(unassigned[0]))
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
    },[])

  
    useEffect(() => {      
       dispatch(updateProjectInfoConfiguration({
        type: 'departmentName',
        value: SelectDepartmentRedux
       }))
    }, [SelectDepartmentRedux]);

    function selectContentType(contentType){ 
        navigate(`/createProject/${param.id}?projectAssetType=${contentType}${projectType?`&projectType=${projectType}`:""}`)
      if (SelectDepartmentRedux.length === 0) {
        setErrorData(true)
      } else {
        if(userPreference !== undefined) {
          userPreference.user.roleSet = null;
          userPreference.user.language = null;
          dispatch(updateContentType(contentType))
          dispatch(setSelectedTreeData([]))
          dispatch(resetProjectRequestIntegrationValue());
          dispatch(resetTree());
          dispatch(resetProjectRequestIntegrationValue());
          dispatch(updateAssetType(Constants.BLANK))
          putAxiosResponse(APIUrls.PROJECT_CONTENT_TYPE_USER_PREFERENCE, userPreference)
          .then((res) => {
            if (res.data.code === 200) {
              dispatch(projectCreationStepFilter("Source Material Step 2"));
              setContentTypeStatus(false)
            }
          })
          .catch((err) => {
            handleError(err);
          });
        }
      }
    }

    const removeErrorAndUpdateSelectedDepartment = (event) => {
      setErrorData(false)
      dispatch(departmentSelected(event))
      let cloneProjectData = JSON.parse(JSON.stringify(projectData))
      cloneProjectData.userGroup = {
        "path": null,
        "applicationVersion": null,
        "id": event.value,
        "name": event.label,
        "createdDate": null,
        "systemGroup": false
      }
      showGlobalOverlay(true);
      putAxiosResponse(APIUrls.PROJECT(param.id), cloneProjectData)
				.then(res => {
          showGlobalOverlay(false);
					if (res.data?.statusCodeValue === 200 || res.data?.status === 'success') {
						let projectResource = transformBlankToNull(res?.data?.data?.resource?.projectResource);
						delete projectResource["owner"];
						delete projectResource["projectFollowers"];
						//deleted  this key as it was giving 400 
						if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
						delete projectResource["workspace"]['workspaceMembers']
						}
						projectResource.intendedUse = {"id":projectResource.intendedUse.id,"name":projectResource.intendedUse.name};
						dispatch(updateProjectInfo(projectResource));
					}
				}).catch(err => {
          showGlobalOverlay(false);
				});
        dispatch(updateReadyForValidation(false));
        dispatch(updateValidationErrors([]));
    }
  const steps=[
    {
      selector: '[createproject-tour="choose-department"]',
      content: "First, select a department"
    },
    {
      selector: '[createproject-tour="local-file"]',
      content: "And let's create a project using a local file"
    },
  ]
  useEffect(()=>{
     dispatch(tourStep(steps));
     $('.lastdisable').trigger('focus')
  },[])
  $(document).ready(function(){
    $(".requiredInput .cw__input").attr({
      'aria-required':'true'
    });
  })
	  
  return (    
      <>
      {/* Intentionally commented <div className="open-draft flex-center">
        Open draft projects
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="#1D4ED8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </div> */}

      {departments.length>0 ? (
        <div className="global-dropdown-block flex-center" >
         <label> {translate("project_listing.department")} </label>
          <div createproject-tour="choose-department">
            <Select className="global-dropdown-select requiredInput" classNamePrefix='cw'
              name="Department"
              aria-label="Department"
              placeholder="Select"
              options={departments}
              defaultValue={SelectDepartmentRedux ? SelectDepartmentRedux?.label : '-- Select a department --'}
              onChange={(event) => removeErrorAndUpdateSelectedDepartment(event)}
              value={departments?.filter(function (department) {
                return department.value === SelectDepartmentRedux.value;
              })}
            >
            </Select>
          </div>
          {errorData && <p className='textDanger'>Please select a department.</p>}
      </div>
      ):Constants.BLANK}
      
      <h5>
        <strong>
          {translate("project_listing.need_translated")}?{" "}
          <span>{translate("project_listing.click_option")}</span>
        </strong>
      </h5>
      <div className="draft-project-list">
        <ul className="flex">
        {integrationTypes.includes("STANDARD") &&

          <li>

            <button className={(projectData.projectContentType==="STANDARD")?"active-box":Constants.BLANK} onClick={()=>selectContentType("STANDARD")} createproject-tour="local-file">

              <div className="image">
               <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                 <path d="M18.3514 9.74656V9.89656H18.5014H29.6909C30.6403 9.89656 31.5509 10.2737 32.2222 10.9451C32.8936 11.6164 33.2707 12.527 33.2707 13.4764V28.3956C33.2688 30.0039 32.629 31.5459 31.4918 32.6832C30.3545 33.8204 28.8125 34.4602 27.2042 34.4621H9.79861C8.19024 34.4602 6.64831 33.8204 5.51102 32.6832C4.37373 31.5459 3.73396 30.0039 3.73203 28.3956L3.73203 8.50328C3.73203 7.55384 4.10919 6.6433 4.78054 5.97195C5.45189 5.3006 6.36244 4.92344 7.31187 4.92344H14.7715C15.721 4.92344 16.6315 5.3006 17.3029 5.97195C17.9742 6.6433 18.3514 7.55384 18.3514 8.50328V9.74656ZM16.0148 9.89656H16.1648V9.74656V8.50328C16.1648 8.13376 16.018 7.77937 15.7567 7.51808C15.4955 7.25679 15.1411 7.11 14.7715 7.11H7.31187C6.94235 7.11 6.58796 7.25679 6.32667 7.51808C6.06538 7.77937 5.91859 8.13376 5.91859 8.50328V28.3958C5.91859 29.4247 6.32736 30.4116 7.05497 31.1392C7.78258 31.8668 8.76943 32.2756 9.79843 32.2756H27.2043C28.2333 32.2756 29.2202 31.8668 29.9478 31.1392C30.6754 30.4116 31.0842 29.4247 31.0842 28.3958V13.4764C31.0842 13.1069 30.9374 12.7525 30.6761 12.4912C30.4148 12.2299 30.0604 12.0831 29.6909 12.0831H9.79843C9.50847 12.0831 9.23039 11.9679 9.02536 11.7629C8.82033 11.5579 8.70515 11.2798 8.70515 10.9898C8.70515 10.6999 8.82033 10.4218 9.02536 10.2168C9.23039 10.0117 9.50847 9.89656 9.79843 9.89656H16.0148Z" fill="#2A4274" stroke="#F4F7FF" strokeWidth="0.3"/>
                 <path d="M21.376 27.4512H9.65752C9.3122 27.4512 8.98101 27.5769 8.73683 27.8008C8.49265 28.0246 8.35547 28.3282 8.35547 28.6447C8.35547 28.9613 8.49265 29.2649 8.73683 29.4887C8.98101 29.7125 9.3122 29.8383 9.65752 29.8383H21.376C21.7213 29.8383 22.0525 29.7125 22.2967 29.4887C22.5409 29.2649 22.678 28.9613 22.678 28.6447C22.678 28.3282 22.5409 28.0246 22.2967 27.8008C22.0525 27.5769 21.7213 27.4512 21.376 27.4512Z" fill="#2A4274"/>
                 <path d="M9.54902 25.0648H14.3232C14.6398 25.0648 14.9433 24.9391 15.1672 24.7152C15.391 24.4914 15.5168 24.1878 15.5168 23.8713C15.5168 23.5547 15.391 23.2512 15.1672 23.0273C14.9433 22.8035 14.6398 22.6777 14.3232 22.6777H9.54902C9.23247 22.6777 8.92888 22.8035 8.70505 23.0273C8.48122 23.2512 8.35547 23.5547 8.35547 23.8713C8.35547 24.1878 8.48122 24.4914 8.70505 24.7152C8.92888 24.9391 9.23247 25.0648 9.54902 25.0648Z" fill="#2A4274"/>
               </svg>
              </div>
              <span>{translate("project_listing.local_files")} </span>
            </button>
          </li>}
          {integrationTypes.includes("ELOQUA") && <li>
            <button className={projectData.projectContentType==="ELOQUA"?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.ELOQUA)}>
              <div className="image">
                <img src={images.ORACLE_LOGO_SVG} alt="Oracle" />
              </div>
              <span>Eloqua</span>
            </button>
          </li>}
          {integrationTypes.includes("MARKETO") &&<li>
            <button className={projectData.projectContentType==="MARKETO"?"active-box":Constants.BLANK}>
              <div className="image">
                <img src={images.MARKATO_LOGO_SVG} alt="Marketo" />
              </div>
              <span>Marketo</span>
            </button>
          </li>}
          {integrationTypes.includes("BRIGHTCOVE") &&<li>
            <button className={projectData.projectContentType==="BRIGHTCOVE"?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.BRIGHTCOVE)}>
              <div className="image">
                <img src={images.BRIGHTCOVE_LOGO} alt="Brightcove" />
              </div>
              <span>Brightcove</span>
            </button>
          </li>}
          {integrationTypes.includes("MARKETOREST") &&<li>
            <button className={projectData.projectContentType==="MARKETOREST"?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.MARKETOREST)}>
              <div className="image">
                <img src={images.MARKATO_LOGO_SVG} alt="MarketoREST" />
              </div>
              <span>MarketoREST</span>
            </button>
          </li>}
          {integrationTypes.includes(Constants.PARDOT) && <li>
            <button className={projectData.projectContentType===Constants.PARDOT?"active-box":Constants.BLANK}  onClick={()=>selectContentType(Constants.PARDOT)}>
              <div className="image">
                <img src={images.SALESFORCE_LOGO} alt="Pardot" />
              </div>
              <span>Pardot</span>
            </button>
          </li>}
          {integrationTypes.includes(Constants.VIDYARD) && <li>
            <button className={projectData.projectContentType===Constants.VIDYARD?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.VIDYARD)}>
              <div className="image">
                <img src={images.VIDYARD_LOGO} alt="Vidyard" />
              </div>
              <span>Vidyard</span>
            </button>
          </li>}
          {integrationTypes.includes(Constants.UBERFLIP) && <li>
            <button className={projectData.projectContentType===Constants.UBERFLIP?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.UBERFLIP)}>
              <div className="image">
                <img src={images.UBERFLIP_LOGO} alt="Uberflip" />
              </div>
              <span>Uberflip</span>
            </button>
          </li>}
          {integrationTypes.includes(Constants.EXACTTARGET) && <li>
            <button className={projectData.projectContentType===Constants.EXACTTARGET?"active-box":Constants.BLANK} onClick={()=>selectContentType(Constants.EXACTTARGET)}>
              <div className="image">
                <img src={images.EXACTTARGET_LOGO} alt="ExactTarget" />
              </div>
              <span>ExactTarget</span>
            </button>
          </li>}
          {integrationTypes.includes("") && <li>
            <button className={projectData.projectContentType===""?"active-box":Constants.BLANK}>
              <div className="image">
                <img
                  src={images.CLOUDWORDS_GLOSSARY}
                  alt="OPAL-Marketing Glossary"
                />
              </div>
              <span>OPAL-Marketing Glossary</span>
            </button>
          </li>}
        </ul>
      </div>  
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>  
      </>
  );
}
